import React from 'react';

export const BlurBackgroundIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_573_6446)">
        <path d="M14.2151 12.1539C14.718 11.6633 15.3068 11.4057 16.0061 11.4057C16.7053 11.4057 17.3064 11.651 17.797 12.1539C18.3 12.6569 18.5453 13.2457 18.5453 13.9449C18.5453 14.6441 18.3 15.2452 17.797 15.7359C17.2941 16.2266 16.7053 16.4842 16.0061 16.4842C15.3068 16.4842 14.7058 16.2388 14.2151 15.7359C13.7121 15.233 13.4668 14.6441 13.4668 13.9449C13.4668 13.2457 13.7121 12.6446 14.2151 12.1539Z" />
        <path d="M10.9275 21.0113V21.7105H21.0846V21.0113C21.0846 20.0545 20.6184 19.3062 19.6861 18.7419C18.7539 18.1776 17.5272 17.8955 16.0061 17.8955C14.485 17.8955 13.2583 18.1776 12.326 18.7419C11.3937 19.3062 10.9275 20.0545 10.9275 21.0113Z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.8937 6.79395H8.10616C5.99624 6.79395 4.2666 8.52358 4.2666 10.6335V21.3671C4.2666 23.4893 5.99624 25.2066 8.10616 25.2066H23.8937C26.0159 25.2066 27.7333 23.477 27.7333 21.3671V10.6335C27.7333 8.51132 26.0036 6.79395 23.8937 6.79395ZM23.906 8.53585C25.0591 8.53585 26.0036 9.48041 26.0036 10.6335V21.3671C26.0036 22.5202 25.0591 23.4647 23.906 23.4647H8.10616C6.95306 23.4647 6.00851 22.5202 6.00851 21.3671V10.6335C6.00851 9.48041 6.95306 8.53585 8.10616 8.53585H23.906Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_573_6446">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
